<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" disabled>{{locale.save}}</button>
    </div>
    <div v-if="userRole !== 'guest'" class="btnGroup">
      <router-link to="/product/item" class="btn btnFull">{{locale.product_create}}</router-link>
      <button type="button" class="btn btnFull btnRed" @click="onRemove">{{locale.delete}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetProductList',
  props: [
    'locale',
    'checked',
    'list'
  ],
  computed: {
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    }
  },
  methods: {
    validateOnRemove () {
      if (!this.checked.length) {
        alert(this.locale.validate_product_delete_noitem)
        return false
      } else {
        return true
      }
    },
    onRemove () {
      let isPassed = this.validateOnRemove()
      if (isPassed) {
        if (window.confirm(this.locale.confirm_delete_product)) {
          const ids = this.checked
          const productList = this.list.filter(x => !ids.includes(x.id))
          this.$store.commit('onLoading', true)
          this.$store.dispatch('product/setProductList', productList).then((res) => {
            alert(this.locale.complete_delete)
            this.$store.dispatch('product/setProductListData').then((res) => {
              this.$emit('uncheckedAll')
              this.$store.commit('onLoading', false)
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btnTemplate {
  display: block;
  margin-right: 0;
  padding: 0.6em 15px;
  border: 1px solid $color-lgrey2;
}
</style>
